import { useContext, useEffect } from 'react';

import { useUserPrint } from '@app/hooks';
import { SendoutsContext } from '@app/providers/SendoutsProvider';
import { useGetSendoutFilterDataQuery } from '@app/services/rtkQuery/Sendouts/api';

export const useFilterFormEffects = () => {
  const { activeBranchId, userId, database } = useUserPrint();
  const {
    statusOptions,
    channelOptions,
    integrationOptions,
    selectedChannelOptions,
    selectedIntegrationOptions,
    selectedStatusOptions,
    setStatusOptions,
    setChannelOptions,
    setIntegrationOptions,
    setSelectedChannelOptions,
    setSelectedIntegrationOptions,
    setSelectedStatusOptions,
  } = useContext(SendoutsContext);

  const { data, isLoading } = useGetSendoutFilterDataQuery(
    {
      params: { ActiveBranchId: activeBranchId },
      logs: {
        isLogged: true,
        userId,
        database,
      },
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (data) {
      setChannelOptions(
        data.Channels.map((channel) => ({
          value: channel.IdS || '',
          label: channel.Name,
        }))
      );
      setIntegrationOptions(
        data.Integrations.map((integration) => ({
          value: integration.Id,
          label: integration.Name,
        }))
      );
      setStatusOptions(
        data.Statuses.map((status) => ({
          value: status.IdS,
          label: status.Name,
        }))
      );
    }
  }, [data, setChannelOptions, setIntegrationOptions, setStatusOptions]);

  return {
    isLoading,
    channelOptions,
    integrationOptions,
    statusOptions,
    selectedChannelOptions,
    selectedIntegrationOptions,
    selectedStatusOptions,
    setSelectedChannelOptions,
    setSelectedIntegrationOptions,
    setSelectedStatusOptions,
  };
};
